import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/cstm-react-datepicker.css";

import "./calender-icon.css";
import { dateFormat2 } from "../../Helper/common";

function ABYear(props) {
  const { paramStartDate, intialStatus, placeholder, fieldName, fieldKey, isRequired, errId, fieldData, index, isDisabled } = props;

  // const [startDate, setStartDate] = useState(paramStartDate);

  const [selectedDate, setSelectedDate] = useState(0);

  const [formData, setFormData] = useState({
    [window.name]: null,
  });

  const handleThirdPartyFloatingLabel = (e) => {
    let parent = e.target.parentElement;
    while (!parent.classList.contains("floating-label"))
      parent = parent.parentElement;

    if (parent.children[1].classList.contains("focused")) {
      //console.log(selectedDate);
      if (selectedDate !== null) {
        return false;
      } else {
        parent.children[1].classList.remove("focused");
      }
    } else {
      parent.children[1].classList.add("focused");
    }
  };

  const dateSelectHandler = (date) => {
    //setStartDate(date);
    // debugger
    setSelectedDate(date);
    if(fieldName == 'digiLocker'){
      props.dateSelect(date, fieldKey, fieldData, index);
    }else{
      props.dateSelect(date);
    }
  };

  useEffect(() => {
    // setSelectedDate(paramStartDate);
    if (paramStartDate !== "" && paramStartDate != undefined && paramStartDate != null) {
      // let dt = new Date(dateFormat2("YYYY", paramStartDate));
      let newDate = new Date(paramStartDate);
      if(newDate != 'Invalid Date'){
        setSelectedDate(newDate);
      }
      //     setSelectedDate(dt);
    }   
    // if (intialStatus === "0") {
    //   setSelectedDate(undefined);
    // }
    // console.log(selectedDate);
    //console.log(startDate);
  }, []);

  let finalClassName="";
  if(fieldName=="digiLocker"){
    finalClassName="";
  }else{
    finalClassName="col-sm-4 col-md-12 col-xl-4";
  }

  return (
    <>
      <div className={finalClassName}>
        <div className="form-group">
          <div className="floating-label has-left-icon react-date-picker">
            <DatePicker
              className="form-control has-icon calendar-icon text-truncate"
              startDate={1980}
              selected={selectedDate}
              onChange={(date) => dateSelectHandler(date)}
              dateFormat="yyyy"
              showYearPicker
              id={props.id}
              onFocus={handleThirdPartyFloatingLabel}
              onBlur={handleThirdPartyFloatingLabel}
              autoComplete="off"
              fixedHeight
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              disabled={isDisabled}
            />
            <label
              htmlFor={props.id}
              className={formData[window.name] || (selectedDate && "focused")}
            >
              {placeholder}
              {isRequired && <sup className="text-danger">*</sup>}
            </label>
          </div>
          <p className="err text-danger" id={fieldKey}>{errId}</p>
        </div>
      </div>
    </>
  );
}

export default ABYear;
